import React from "react";

interface Props {
    date: Date;
}

const Date: React.FC<Props> = ({ date }) => {

    const hours = `${date.getHours() < 10 ? "0" : ""}${date.getHours()}`
    const min = `${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}`
    const sec = `${date.getSeconds() < 10 ? "0" : ""}${date.getSeconds()}`
    return (
        <span title={date.toLocaleString()}>
            {hours}:{min}:{sec}
        </span>
    );
};

export default Date;
